import React, { createContext, useContext, useReducer } from "react";
import { ACTION_TYPES, UnidadesSaudeReducer, UnidadesSaudeState } from "./unidades-saude-reducer";
import { PaginationResponse } from "models/pagination-response";
import { IUnidadeSaudePagedResponse } from "models/response/unidade-saude-paged-response";

const UnidadesSaudeContext = createContext<UnidadesSaudeState | undefined>(undefined);
const UnidadesSaudeContextDispatchContext = createContext({} as any);

const UnidadesSaudeProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(UnidadesSaudeReducer, {
        unidadesSaude: new PaginationResponse<IUnidadeSaudePagedResponse>([], 0, 1, 10, 0),
        unidadeSaudePagedRequest: { page: 0, pageSize: 10 },
        loading: false,
        error: null
    } as UnidadesSaudeState);

    return (
        <UnidadesSaudeContext.Provider value={state}>
            <UnidadesSaudeContextDispatchContext.Provider value={dispatch}>
                {children}
            </UnidadesSaudeContextDispatchContext.Provider>
        </UnidadesSaudeContext.Provider>
    );
}

const useUnidadesSaudeState = () => {
    const context = useContext(UnidadesSaudeContext);
    if (context === undefined) {
        throw new Error('useUnidadesSaudeState must be used within a UnidadesSaudeProvider');
    }
    return context;
}

const useUnidadesSaudeDispatch = () => {
    const context = useContext(UnidadesSaudeContextDispatchContext);
    if (context === undefined) {
        throw new Error('useUnidadesSaudeDispatch must be used within a UnidadesSaudeProvider');
    }
    return context;
}

export { UnidadesSaudeProvider, useUnidadesSaudeState, useUnidadesSaudeDispatch, ACTION_TYPES };
